import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChatBubbleOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chat_bubble_outline"}/>
}
